import { API_BASE_URL_MAP, BASE_URL_MAP } from '../constants'
import { STAGE } from '../constants/environments'

export const getBaseUrl = (): string => window.location.host
export const getEnvironment = (): string => BASE_URL_MAP[getBaseUrl()] || STAGE
export const getApiBaseURL = (): string => API_BASE_URL_MAP[getEnvironment()]
